import { Outlet } from 'react-router-dom'

import { ProductTour } from '@/components/shared/ProductTour'
import { TooltipProvider } from '@/components/ui/tooltip'

import { AppSidebar } from './AppSidebar'
import { AppTopbar } from './AppTopbar'

export function AppLayout() {
  return (
    <TooltipProvider delayDuration={300}>
      <div className="min-h-screen flex w-full bg-background">
        <AppSidebar />
        <div className="flex-1 flex flex-col w-full overflow-auto">
          <AppTopbar />
          <main className="flex-1" data-tour="main-content">
            <Outlet />
          </main>
        </div>
      </div>
      <ProductTour />
    </TooltipProvider>
  )
}
